/*
 * TunePad
 *
 * Michael S. Horn
 * Northwestern University
 * michael-horn@northwestern.edu
 *
 * This project was funded by the National Science Foundation (grant DRL-1612619).
 * Any opinions, findings and conclusions or recommendations expressed in this
 * material are those of the author(s) and do not necessarily reflect the views
 * of the National Science Foundation (NSF).
 */
import { Creator, Renderer } from 'easy-qrcode';


/**
 * QR Code
 * ```html
 * <qr-code link="https://..." width="300" height="300"></qr-code>
 * ```
 */
export class QRCode extends HTMLElement {

    static readonly ELEMENT = "qr-code";

    static DefineElement() {
        if (customElements.get(QRCode.ELEMENT) === undefined) {
            customElements.define(QRCode.ELEMENT, QRCode);
        }
    }

    static observedAttributes = [
        'link',
        'width',
        'height'
    ];


    private canvas : HTMLCanvasElement;


    constructor() {
        super();
        this.canvas = document.createElement('canvas');
    }

    connectedCallback() {
        this.append(this.canvas);
        if (this.hasAttribute('link')) {
            this.generateQRCode(this.getAttribute('link')!);
        }
    }

    disconnectedCallback() { }


    attributeChangedCallback(name : string, oldValue : string, newValue : string) {
        if (name === 'link' && newValue && newValue !== oldValue) {
            this.generateQRCode(newValue);
        }
        else if (name === 'width') {
            this.canvas.setAttribute('width', newValue);
        }
        else if (name === 'height') {
            this.canvas.setAttribute('height', newValue);
        }
    }


    private generateQRCode(url : string) {
        const qrCreator = new Creator();
        const qrRenderer = new Renderer();
        qrCreator.add(url);
        qrCreator.create();
        const matrix = qrCreator.getMatrix();
        qrRenderer.drawCanvas(matrix, this.canvas);
    }
}
